// @flow

export const YELLOW: "yellow" = "yellow";
export const GREEN: "green" = "green";
export const GREY: "grey" = "grey";
export const RED: "red" = "red";

export const statuses = {
  customer: {
    pending: {
      color: YELLOW,
      label: "Ausstehend"
    },
    waiting: {
      color: YELLOW,
      label: "Unterlagen fehlen"
    },
    new: {
      color: YELLOW,
      label: "Neu"
    },
    in_process: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    offer_pending: {
      color: YELLOW,
      label: "Angebot liegt vor"
    },
    contract_done: {
      color: GREEN,
      label: "Abschluss erfolgt"
    },
    archived: {
      color: GREY,
      label: "Archiviert"
    }
  },
  bubaCustomer: {
    new: {
      color: RED,
      label: "Ungeöffnet"
    },
    opened: {
      color: RED,
      label: "Geöffnet"
    },
    processing_pending: {
      color: RED,
      label: "Bearbeitung ausstehend"
    },
    forwarding_pending: {
      color: RED,
      label: "Weiterleitung ausstehend"
    },
    forwarded: {
      color: YELLOW,
      label: "Bearbeitung bei Bank"
    },
    contract_done: {
      color: GREEN,
      label: "Abschluss erfolgt"
    },
    external_pool_extension: {
      color: GREEN,
      label: "Externe Poolerweiterung"
    },
    dropped: {
      color: GREY,
      label: "Sonstiges"
    }
  },
  bubaBankAdvisor: {
    new: {
      color: RED,
      label: "Neu"
    },
    opened: {
      color: RED,
      label: "Geöffnet"
    },
    awaiting_fides_sync: {
      color: YELLOW,
      label: "Warten auf Antragsdaten aus Fides4"
    },
    awaiting_fides_transfer: {
      color: YELLOW,
      label: "Fides4 Übertrag ausstehend"
    },
    awaiting_fides_transfer_retry: {
      color: YELLOW,
      label: "Fides4 Übertrag ausstehend"
    },
    awaiting_fides_transfer_failed: {
      color: RED,
      label: "Fides4 Übertrag fehlgeschlagen"
    },
    awaiting_fides_decision: {
      color: YELLOW,
      label: "Warten auf Entscheidung aus Fides4"
    },
    awaiting_guarantee_interest: {
      color: YELLOW,
      label: "Interessensbekundung notwendig"
    },
    awaiting_creator_feedback: {
      color: YELLOW,
      label: "Rückmeldung des Bankmitarbeiters ausstehend"
    },
    processing_pending: {
      color: YELLOW,
      label: "Bearbeitung ausstehend"
    },
    positive_decision: {
      color: GREEN,
      label: "Positive Entscheidung"
    },
    negative_decision: {
      color: RED,
      label: "Negative Entscheidung"
    },
    completed: {
      color: GREEN,
      label: "Abgeschlossen"
    },
    canceled: {
      color: GREY,
      label: "Abgelehnt"
    },
    dropped: {
      color: GREY,
      label: "Archiviert"
    },
    archived: {
      color: GREY,
      label: "Archiviert"
    }
  },
  bubaOffer: {
    not_forwarded: {
      color: RED,
      label: "Weiterleitung ausstehend"
    },
    new: {
      color: YELLOW,
      label: "Vorprüfung ausstehend"
    },
    opened: {
      color: YELLOW,
      label: "Vorprüfung ausstehend"
    },
    in_process: {
      color: YELLOW,
      label: "Genehmigung ausstehend"
    },
    offer_submitted: {
      color: GREEN,
      label: "Abschluss ausstehend"
    },
    contract_done: {
      color: GREEN,
      label: "Abgeschlossen"
    },
    declined_by_bank: {
      color: RED,
      label: "Abgelehnt"
    },
    declined_by_customer: {
      color: RED,
      label: "Abgelehnt"
    },
    expired: {
      color: RED,
      label: "Abgelaufen"
    }
  },
  ba_inquiry: {
    new: {
      color: RED,
      label: "Neu"
    },
    opened: {
      color: YELLOW,
      label: "Geöffnet"
    },
    processing_pending: {
      color: YELLOW,
      label: "Bearbeitung ausstehend"
    },
    contract_done: {
      color: GREEN,
      label: "Abschluss erfolgt"
    },
    dropped: {
      color: GREY,
      label: "Archiviert"
    },
    awaiting_fides_sync: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_creator_feedback: {
      color: YELLOW,
      label: "Rückmeldung erforderlich"
    },
    awaiting_contract_confirmation: {
      color: YELLOW,
      label: "Entscheidung ausstehend"
    },
    completed: {
      color: GREEN,
      label: "Abgeschlossen"
    },
    awaiting_fides_transfer: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_transfer_retry: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_transfer_failed: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_decision: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_guarantee_interest: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    archived: {
      color: GREY,
      label: "Archiviert"
    },
    canceled: {
      color: RED,
      label: "Abgelehnt"
    }
  },
  bank: {
    new: {
      color: RED,
      label: "Neu"
    },
    opened: {
      color: YELLOW,
      label: "Geöffnet"
    },
    in_process: {
      color: YELLOW,
      label: "Interesse bekundet"
    },
    processing_pending: {
      color: YELLOW,
      label: "Interesse bekundet"
    },
    offer_submitted: {
      color: YELLOW,
      label: "Angebot abgegeben"
    },
    contract_done: {
      color: GREEN,
      label: "Abschluss erfolgt"
    },
    declined_by_bank: {
      color: RED,
      label: "Abgelehnt Bank"
    },
    awaiting_fides_sync: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_transfer: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_transfer_retry: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_fides_transfer_failed: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_guarantee_interest: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    awaiting_creator_feedback: {
      color: YELLOW,
      label: "Rückmeldung erforderlich"
    },
    awaiting_fides_decision: {
      color: YELLOW,
      label: "In Bearbeitung"
    },
    declined_by_customer: {
      color: RED,
      label: "Abgelehnt Kunde"
    },
    expired: {
      color: RED,
      label: "Abgelaufen"
    },
    archived: {
      color: GREY,
      label: "Archiviert"
    },
    canceled: {
      color: RED,
      label: "Abgelehnt"
    },
    completed: {
      color: GREEN,
      label: "Abgeschlossen"
    }
  }
};
